import {Term} from '../../terms/components/TermsComponent';

export const contests: Term[] = [
  {
    id: '15.1',
    term:
      "By entering our contests, users consent to the use of their name or pseudonym in the announcement of the winners on our website and use of their name and likeness for advertising, promotional, and marketing purposes. Users' contact information may also be used to notify the user they have won and to confirm their mailing address.",
  },
];
